import React from "react";
import { Github, Linkedin, Mail, Heart } from "lucide-react";
import { personalInfo, navLinks, socialLinks } from "../../data/mock";

const iconMap = { Github, Linkedin, Mail };

const Footer = () => {
  const handleClick = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const offset = 80;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[rgb(26,28,30)] border-t border-[rgba(255,255,255,0.1)] mt-16">
      <div className="max-w-[1200px] mx-auto px-6 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Branding */}
          <div className="lg:col-span-2">
            <a href="#" className="text-xl font-bold text-white tracking-tight">
              <span className="text-[rgb(218,255,1)]">A</span>ditya
              <span className="text-[rgb(218,255,1)]">.dev</span>
            </a>
            <p className="text-sm text-[rgb(161,161,170)] mt-3 max-w-sm leading-relaxed">
              Full Stack MERN Developer building scalable web applications.
              Passionate about clean code and great user experiences.
            </p>
            {/* Social links */}
            <div className="flex gap-3 mt-5">
              {socialLinks.map((link) => {
                const Icon = iconMap[link.icon];
                return (
                  <a
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-lg bg-[rgb(38,40,42)] flex items-center justify-center text-[rgb(161,161,170)] hover:bg-[rgb(218,255,1)] hover:text-[rgb(17,17,19)] hover:-translate-y-0.5 transition-all duration-200"
                    aria-label={link.label}
                  >
                    {Icon && <Icon size={18} />}
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleClick(e, link.href)}
                    className="text-sm text-[rgb(161,161,170)] hover:text-[rgb(218,255,1)] transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Get in Touch
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href={`mailto:${personalInfo.email}`}
                  className="text-sm text-[rgb(161,161,170)] hover:text-[rgb(218,255,1)] transition-colors duration-200"
                >
                  {personalInfo.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${personalInfo.phone}`}
                  className="text-sm text-[rgb(161,161,170)] hover:text-[rgb(218,255,1)] transition-colors duration-200"
                >
                  {personalInfo.phone}
                </a>
              </li>
              <li>
                <span className="text-sm text-[rgb(161,161,170)]">
                  {personalInfo.location}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[rgba(255,255,255,0.06)] mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[rgb(161,161,170)]">
            &copy; {new Date().getFullYear()} {personalInfo.name}. All rights reserved.
          </p>
          <p className="flex items-center gap-1.5 text-xs text-[rgb(161,161,170)]">
            Built with <Heart size={12} className="text-[rgb(218,255,1)]" /> using React & Tailwind CSS
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
